<div class="container-fluid p-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="fs-3 fw-light mb-0"><strong>Dashboard</strong> - Indicadores do Sistema</h1>
        <button mat-icon-button color="primary" (click)="atualizarManualmente()" [disabled]="loading" matTooltip="Atualizar indicadores">
            <mat-icon [class.spin]="loading">refresh</mat-icon>
        </button>
    </div>

    <mat-spinner class="mx-auto my-5" *ngIf="loading && !dashboardData"></mat-spinner>

    <mat-tab-group *ngIf="dashboardData" mat-stretch-tabs="false">
        <mat-tab>
            <ng-template mat-tab-label>
                Indicadores Diários
            </ng-template>
            <app-dashboard-indicadores-diarios></app-dashboard-indicadores-diarios>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Indicadores Semanais
            </ng-template>
            <app-dashboard-indicadores-semanais></app-dashboard-indicadores-semanais>
        </mat-tab>        
        <mat-tab>
            <ng-template mat-tab-label>
                Indicadores Mensais
            </ng-template>
            <!-- INDICADORES MENSAIS -->
            <mat-card class="mb-4">
                <mat-card-header class="mb-3">
                    <mat-card-title class="fs-5 fw-bold text-primary">
                        <mat-icon class="align-middle me-2">calendar_month</mat-icon>
                        Indicadores do Mês Vigente - {{ today | date:'MMMM' }}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row g-3">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let indicador of indicadoresMensais">
                            <mat-card class="h-100 card-indicador">
                                <mat-card-content class="text-center p-3">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <mat-icon [class]="getCorClasse(indicador.cor)" class="fs-1">{{ indicador.icone }}</mat-icon>
                                        <button mat-icon-button 
                                                [matTooltip]="indicador.descricao + ' (' + indicador.periodicidade + ')'" 
                                                matTooltipClass="tooltip-multiline">
                                            <mat-icon class="fs-6 text-muted">info</mat-icon>
                                        </button>
                                    </div>
                                    <h3 class="fs-2 fw-bold mb-1">{{ indicador.valor }}</h3>
                                    <p class="fs-6 text-muted mb-0">{{ indicador.titulo }}</p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Indicadores Anuais
            </ng-template>
            <app-dashboard-indicadores-anuais></app-dashboard-indicadores-anuais>
        </mat-tab>      
    </mat-tab-group>

    <!-- INDICADORES GERAIS -->
    <ng-container *ngIf="dashboardData">
        <app-dashboard-geral [dashboardData]="dashboardData"></app-dashboard-geral>
    </ng-container>

    <!-- CRONÔMETRO REGRESSIVO -->
    <div class="timer-container" *ngIf="dashboardData">
        <mat-card class="timer-card">
            <mat-card-content class="p-2 d-flex align-items-center">
                <mat-icon class="me-2 text-primary">schedule</mat-icon>
                <span class="fs-7"><strong>{{ formatarTempoRestante() }}</strong></span>
            </mat-card-content>
        </mat-card>
    </div>
</div>
